interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps): JSX.Element {
  return (
    <footer className={`text-center text-xs leading-5 text-text-tertiary ${className ?? ""}`}>
      <p>AI 不動産案件 OS v0.1.0</p>
      <p className="mt-1">© 2026 Nroom</p>
    </footer>
  );
}
